<template lang="pug">
  .project-files-container
    ProjectFileFrame(v-for="(fileData, index) in filesData" @changeFileSelection="changeFileSelection"
      @clickMenu="clickMenu" :key="fileData.id" :fileData="fileData" :orientationType="orientationType"
      :selected="fileData.selected" class="project-file" :fileIndex="index"
      @fileDragStart="fileDragStart" @fileDrag="fileDrag" @viewImage="setViewedImage")
</template>

<script>
import ProjectFileFrame from '@/components/project/ProjectFileFrame.vue';
import fileTypes from '@/utils/fileTypes';
import popupModel from '@/model/popup';

export default {
  name: 'ProjectFilesContainer',
  components: { ProjectFileFrame },
  props: {
    filesData: {
      type: Array,
      default: () => [],
    },
    orientationType: {
      type: String,
      default: 'square',
    },
  },
  computed: {
    images() {
      return this.filesData
        .filter((i) => fileTypes[i.file.extension]?.hasPreview)
        .map(f => ({
          ...f,
          info: fileTypes[f.file.extension] ?? {},
        }));
    },
  },
  methods: {
    changeFileSelection(fileDataId) {
      this.$emit('changeFileSelection', fileDataId);
    },
    clickMenu(action, fileData) {
      this.$emit('clickMenu', action, fileData);
    },
    fileDragStart(e, fileData) {
      this.$emit('fileDragStart', e, fileData);
    },
    fileDrag(e) {
      this.$emit('fileDrag', e);
    },
    // просмотр — через диспетчер попапов (BasePreview), а не из своей разметки
    setViewedImage(file) {
      const items = this.images.map(i => ({ type: i.info.type, src: i.file.url }));
      const index = this.images.findIndex(i => i.id === file.id);
      popupModel.addPreview(items, index);
    },
  },
};
</script>

<style scoped lang="scss">
  .project-files-container {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 15px;
  }
</style>
